// extracted by mini-css-extract-plugin
export default {"cls1":"Jfr6xMX_ZJxGKTyELnDp","cls2":"DffOwxWqSEkezXnmrSBr Jfr6xMX_ZJxGKTyELnDp"};